import { createReducer, on, Action } from '@ngrx/store';

import * as FeatureActions from './user.actions';
import { UserState } from './user.models';

export const USER_FEATURE_KEY = 'user';

export interface UserPartialState {
  readonly [USER_FEATURE_KEY]: UserState;
}

export const initialUserState: UserState = {
  userId: null,
};

const reducer = createReducer(
  initialUserState,
  on(FeatureActions.initUser, (state, { userId }) => ({
    ...state,
    userId,
  }))
);

export function userReducer(state: UserState | undefined, action: Action): UserState {
  return reducer(state, action);
}
